const { styled } = require('@mui/material');

export const StyledPrintOrder = styled('div')`
  @media print {
    page-break-after: always;
  }
  margin-top: 4px;

  .footer-print {
    width: 100%;
    padding: 0 30px;
    overflow: hidden; /* contain the floated signature block */

    .signature {
      float: right;
      text-align: center;
      font-size: 12px;
      break-inside: avoid; /* keep label + sign space together on one page */
    }

    .signature p {
      margin: 0;
    }

    .doctor-label {
      font-weight: 700;
      margin-top: 2px;
    }

    .signature-space {
      height: 60px; /* blank room for the doctor's signature */
    }
  }
`;

export const StyledHeader = styled('div')`
  .header-print {
    display: flex;
    justify-content: space-between;
    padding-left: 12px;
    padding-right: 24px;
    align-items: center;

    .logo-invoice {
      img {
        width: 110px;
      }
    }

    .address {
      margin-top: 2px;

      h4 {
        margin-top: 0;
        text-align: center;
        font-weight: 800;
        font-size: 13px;
        margin-bottom: 2px;
      }

      p {
        margin-top: 0;
        font-weight: 600;
        font-size: 11px;
        margin-bottom: 1px;
        text-align: center;
      }
    }
  }

  .divider {
    width: 80%;
  }

  .title-print {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 1px;
    margin-bottom: 0;
    margin-top: 8px;
  }

  .customer-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    row-gap: 2px;
    padding: 4px 40px;
    font-size: 12px;

    /* SĐT trên 1 dòng, không xuống dòng */
    .nowrap {
      white-space: nowrap;
    }

    /* Địa chỉ chiếm trọn 1 dòng riêng (vì dài) */
    .address-line {
      grid-column: 1 / -1;
    }
  }
`;

export const StyledTestResult = styled('div')`
  padding: 0 25px;

  .glass-info {
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .border {
    border: 1px solid gray;
    padding: 1px 3px;
    font-size: 12px;
  }

  .header {
    font-weight: 600;
  }

  .eye {
    width: 15%;
  }

  .thi-luc {
    width: 19%;
  }

  .sbdt {
    width: 28%;
  }

  .prescription-title {
    font-weight: 600;
    text-decoration: underline;
    margin-top: 3px;
    font-size: 12px;
  }

  .text-col {
    display: flex;
    gap: 12px;
    margin: 6px 0;
    font-size: 12px;

    /* Prescription: title on top, list spans full width (so usage text doesn't
       get squeezed by the title beside it). */
    &.prescription {
      flex-direction: column;
      gap: 2px;
    }

    /* Long prescriptions (>5 items) flow into 2 columns to use the side
       whitespace and save vertical space. Auto-balanced by the browser. */
    .detail.two-cols {
      column-count: 2;
      column-gap: 28px;
    }

    .diagnose-item {
      margin: 1px 0;
      font-style: italic;
      break-inside: avoid; /* keep each medicine intact within its column */
      span {
        margin-left: 6px;
      }
    }
  }

  .note-result {
    width: 100%;
    text-align: center;
    ont-size: 13px;
    font-weight: lighter;
    font-style: italic;
    font-size: 10px;
  }

  /* Footer 2 cột: trái = ngày khám lại + ghi chú, phải = ngày khám + chữ ký.
     Đặt song song để tận dụng khoảng trắng bên phải và tránh tụt sang trang 2. */
  .result-footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 24px;
    margin-top: 12px;
    break-inside: avoid; /* giữ cả khối footer trên cùng 1 trang */
  }

  .result-footer-left {
    flex: 1;
  }

  .result-footer .order-note {
    margin: 0 0 6px;
    font-size: 12px;
  }

  .result-footer .signature {
    flex-shrink: 0;
    min-width: 200px;
    text-align: center;
    font-size: 12px;
  }

  .result-footer .signature p {
    margin: 0;
  }

  .result-footer .doctor-label {
    font-weight: 700;
    margin-top: 2px;
  }

  .result-footer .signature-space {
    height: 60px; /* chừa chỗ ký tên */
  }
`;

export const StyledInvoicePrint = styled('div')`
  padding: 6px 25px;

  .border {
    border: 1px solid gray;
    padding: 3px 3px;
    font-size: 12px;
  }

  .header {
    font-weight: 600;
  }

  .total-payment {
    width: 100%;
    text-align: right;
    font-weight: 600;
    margin: 10px 0;
    font-size: 12px;

    p {
      margin: 2px;
    }
  }
`;

export const StyledPrintDialog = styled('div')`
  padding: 16px;

  .btn-group {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
  }
`;
